<template>
  <div class="myCollege">
    <div class="myCollege-title">
      <div class="myCollege-title-search">
        <el-input
          placeholder="请输入搜索内容"
          prefix-icon="el-icon-search"
          v-model="searchInput"
          @blur="querySchoolExperiment"
          @keyup.native.enter="querySchoolExperiment"
        >
        </el-input>
      </div>
      <div class="myCollege-title-sort">
        <span>学科分类：</span>
        <div class="sort-list">
          <div
            class="list"
            :class="IDList.tagId == item.id ? 'list-active' : ''"
            v-for="item in subjectList.tag"
            :key="item.id"
            @click="clickSerarch('tagId', item.id)"
          >
            <span>{{ item.name }}</span
            ><i>({{ item.num }})</i>
          </div>
        </div>
      </div>
      <div class="myCollege-title-sort">
        <span>学院：</span>
        <div class="sort-list">
          <div
            class="list"
            :class="
              IDList.collegeId == item.id ? 'list-active' : ''
            "
            v-for="item in subjectList.college"
            :key="item.id"
            @click="clickSerarch('collegeId', item.id)"
          >
            <span>{{ item.name }}</span
            ><i>({{ item.num }})</i>
          </div>
        </div>
      </div>
      <div class="myCollege-title-sort">
        <span>课程认定：</span>
        <div class="sort-list">
          <div
            class="list"
            :class="IDList.level == item.id ? 'list-active' : ''"
            v-for="item in subjectList.level"
            :key="item.id"
            @click="clickSerarch('level', item.id)"
          >
            <span>{{ item.name }}</span
            ><i>({{ item.num }})</i>
          </div>
        </div>
        <!-- <el-select v-model="level" placeholder="不限" size="small" @change="levelSearch">
          <el-option
            v-for="item in subjectList.level"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select> -->
      </div>
    </div>
    <div class="myCollege-container" v-if="experimentList.length > 0">
      <div class="card" v-for="item in experimentList" :key="item.id">
        <experimentCard :detail="item"></experimentCard>
      </div>
    </div>
    <noDate v-else :tip="'暂无实验'" style="padding-top:100px;padding-bottom:70px"></noDate>
    <el-pagination
      v-if="experimentList.length > 0"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[8,12, 16, 20, 24]"
      :page-size="8"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalItems"
    >
    </el-pagination>
  </div>
</template>

<script>
import experimentCard from "@/components/experimentCard.vue";
import noDate from '@/components/common/noData.vue'
export default {
  name: "VirtualimitationIndex",
  components: { experimentCard,noDate },
  data() {
    return {
      IDList: { tagId: -1, collegeId: -1, level: -1 },
      subjectList: {
        college: [],
        level: [],
        tag: [],
      }, //实验类别
      level: 0, //评级认定
      searchInput: "",
      currentPage: 1,
      params: {
        collegeId: 0,
        level: 0, //等级认定
        name: "",
        pageIndex: 1,
        showItem: 8,
        status: 0, //我的实验，0 待学习 1 已完成 2 收藏
        tagId: 0, //学科分类
      },
      experimentList: [],
      totalItems: 0,
    };
  },

  mounted() {
    this.getSchoolExperimentKinds();
    this.querySchoolExperiment();
  },

  methods: {
    //回车
    clickEnter(){

    },
    //搜索实验
    querySchoolExperiment() {
      this.params.name = this.searchInput.trim();
      this.$api.experiment.querySchoolExperiment(this.params).then((res) => {
        if (res.data != null && res.errCode == 0) {
          this.experimentList = res.data.items;
          this.totalItems = res.data.totalItems;
        } else {
          this.$message.error(res.errMsg);
        }
      });
    },
    clickSerarch(type, id) {
      // this.params.collegeId = 0;
      // this.params.level = 0;
      // this.params.tagId = 0;
      this.params[type] = id;
      this.IDList[type] = id;
      // this.active = type + "" + id;   
      this.querySchoolExperiment();
    },
    //获取本校学科类别
    getSchoolExperimentKinds() {
      this.$api.experiment.getSchoolExperimentKinds().then((res) => {
        if (res.data != null && res.errCode == 0) {
          this.subjectList = res.data;
        } else {
          this.$message.error(res.errMsg);
        }
      });
    },
    handleSizeChange(val) {
      this.params.pageIndex = 1;
      this.params.showItem = val;
      this.querySchoolExperiment();
    },
    handleCurrentChange(val) {
      this.params.pageIndex = val;
      this.querySchoolExperiment();
    },
  },
};
</script>

<style lang="less" scoped>
.myCollege {
  flex: 1;
  width: 100%;
  // background: #fff;
  .myCollege-title {
    width: 100%;
    background: #fff;
    padding: 34px 51px;
    box-sizing: border-box;
    .myCollege-title-sort {
      display: flex;
      justify-content: start;
      //   margin-bottom: 41px;
      padding-top: 19px;
      padding-bottom: 19px;
      border-bottom: 1px solid #eef2fa;
      .sort-list {
        display: flex;
        justify-content: start;
        margin-left: 23px;
        flex-wrap: wrap;
        .list {
          margin-right: 20px;
          cursor: pointer;
          &:hover {
            span,
            i {
              color: #1880fa !important;
            }
          }
          span,
          i {
            width: 1228px;
            height: 50px;
            font-size: 14px;
            font-family: PingFang-SC;
            font-weight: 400;
            line-height: 30px;
            color: #898989;
            opacity: 1;
            font-style: normal;
          }
          span {
            color: #101012;
          }
        }
      }
      & > span {
        display: block;
        width: 70px;
        height: 20px;
        font-size: 14px;
        font-family: PingFang-SC;
        font-weight: 400;
        color: #99a7c3;
        opacity: 1;
        flex-shrink: 0;
        line-height: 30px;
      }
    }
    .myCollege-title-course {
      display: flex;
      justify-content: start;
      padding-top: 24px;
      & > span {
        display: block;
        width: 70px;
        height: 20px;
        font-size: 14px;
        font-family: PingFang-SC;
        font-weight: 400;
        line-height: 20px;
        color: #99a7c3;
        opacity: 1;
        margin-right: 23px;
      }
      .el-select {
        width: 103px;
      }
    }
    .myCollege-title-search {
      width: 604px;
      height: 42px;
      margin: 0 auto;
      margin-bottom: 30px;
      .el-input {
        width: 604px;
      }
    }
  }
  .myCollege-container {
    margin-top: 16px;
    display: flex;
    justify-content: start;
    flex-wrap: wrap;
    .card {
      margin-right: 10px;
      margin-bottom: 18px;
      &:nth-child(4n) {
        margin-right: 0;
      }
    }
  }
  .el-pagination {
    text-align: center;
    margin-top: 45px;
    margin-bottom: 16px;
  }
}
.list-active {
  span,
  i {
    color: #1880fa !important;
  }
}
</style>